<div class="custom-snackbar">
  <mat-icon class="custom-snackbar_icon" [ngClass]="'custom-snackbar_icon--' + type">
    {{ icon }}
  </mat-icon>

  <p class="custom-snackbar_text">
    {{ message }}
  </p>

  <button *ngIf="action" class="custom-snackbar_button" (click)="action.callback()">
    {{ action.text }}
  </button>
</div>
